"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enterpriseQuotePortalService = void 0;
const enterprise_quote_portal_service_1 = require("./enterprise-quote-portal-service");
const query_client_1 = require("../query-client");
exports.enterpriseQuotePortalService = new enterprise_quote_portal_service_1.EnterpriseQuotePortalService({
    resource: 'enterprise-quote-portal',
    parentResources: [],
    middleware: [],
    queryClient: query_client_1.queryClient,
});
